
import Vue from 'vue'

// Vue instance acting as app-wide event-bus
export const WguEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/WguEventBus.js